/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const SelectOrganizationRequest = zod
	.object({
		organization_id: zod.uuid().describe('Organization ID to select')
	})
	.describe('Request body for selecting an organization');

export type SelectOrganizationRequest = zod.input<typeof SelectOrganizationRequest>;
export type SelectOrganizationRequestOutput = zod.output<typeof SelectOrganizationRequest>;
